import axios from '../http'

function query(data) {
    return axios.post('/event/boatLane/query', data);
}

function get(id) {
    return axios.get('/event/boatLane/get?id=' + id);
}

function choose(data) {
    return axios.post('/event/boatLane/choose', data);
}

function batchChoose(data, lane) {
    return axios.post('/event/boatLane/batchChoose?lane='+lane, data);
}


function adjust(data) {
    return axios.post('/event/boatLane/adjust', data);
}


function batchConfirm(data) {
    return axios.post('/event/boatLane/batchConfirm', data);
}


function printPreLanes(projectId) {
    const url = "/event/boatLane/printPreLanes?projectId="+projectId;
    return axios.get(url, { responseType: 'blob' }).then((res) => {
        const pdfUrl = window.URL.createObjectURL(new Blob([res], { type: 'application/pdf;charset=UTF-8'}));
        const newWindow = window.open(pdfUrl);
        window.URL.revokeObjectURL(newWindow);
    })
}

export default {
    query,
    get,
    choose,
    adjust,
    batchChoose,
    batchConfirm,
    printPreLanes
}